module.exports = __webpack_public_path__ + "img/monitor02.369cca05.png";